import {
  DropDownItemsStoreAction,
  DropDownItemsStoreKind,
  DropDownItemsStoreType,
} from './dropDownItemsStore.types';

export const INITIAL_DROPDOWN_ITEMS = {
  region: [],
  country: [],
  sector: [],
  sector2: [],
  typeOfProjectPartner: [],
};

const dropDownItemsStore = (
  state: DropDownItemsStoreType,
  action: DropDownItemsStoreAction
): DropDownItemsStoreType => {
  switch (action.type) {
    case DropDownItemsStoreKind.INITIAL: {
      return { ...state, ...action.payload };
    }
    default:
      throw new Error();
  }
};

export default dropDownItemsStore;
